module.exports = __webpack_public_path__ + "img/image_testi_borrower_1.dd9df126.png";